let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9cjn0")).then(() => parcelRequire('lP4VJ'));